import { TAGS } from "@/store/api.ts"
import { createSocketBase } from "@/store/apis/socket.factory"
import {
  addEvent,
  setEventFulfilled,
  setIsSocketConnected,
  setLastStateReceivedAt
} from "@/store/slices/gameplay"
import { deckEndpoints } from "../deckAPI"
import { effectsApi, effectsEndpoints } from "../effectsAPI"
import { gameplayEndpoints } from "./gameplay.api"
import { gameplayResilience } from "./gameplay.resilience"
import {
  GAMEPLAY_PHASE,
  GAMEPLAY_SOCKETS,
  IGameplayEvent,
  IGameplayStateEvent,
  IGameplayStateResponse
} from "./gameplay.types"

export const socketGameplay = {
  ...createSocketBase("gameplay"),
  updateGameplayStateData: null as
    | ((updater: (draft: IGameplayStateResponse) => void) => void)
    | null,

  init(sessionId: string) {
    this._init({
      auth: sessionId ? { sessionId } : undefined,
      onConnect: () => this.dispatch?.(setIsSocketConnected(true)),
      onConnectError: () => this.dispatch?.(setIsSocketConnected(false)),
      onDisconnect: () => this.dispatch?.(setIsSocketConnected(false)),
      onReconnect: () => {
        this.dispatch?.(setIsSocketConnected(true))
        this.dispatch?.(
          gameplayEndpoints.util.invalidateTags([{ type: TAGS.GAMEPLAY }])
        )
        this.dispatch?.(
          deckEndpoints.util.invalidateTags([{ type: TAGS.DECK }])
        )
        this.dispatch?.(
          effectsApi.util.invalidateTags([{ type: TAGS.EFFECTS }])
        )
      }
    })
  },

  setUpdateGameplayStateData(
    updateCachedData: (updater: (draft: IGameplayStateResponse) => void) => void
  ) {
    this.updateGameplayStateData = updateCachedData
  },

  bindGameplayStateListener() {
    const handler = (event: IGameplayStateEvent) => {
      console.log("bindGameplayStateListener", event)

      this.dispatch?.(setLastStateReceivedAt(Date.now()))

      if (event.phase === GAMEPLAY_PHASE.ACTION) {
        const { currentCardPlayedBy: _, prevCardPlayedBy: __, ...rest } = event

        this.updateGameplayStateData?.((draft) => {
          Object.assign(draft, rest)
        })
      } else {
        this.updateGameplayStateData?.((draft) => {
          Object.assign(draft, event)
        })
      }

      gameplayResilience.onStateReceived()

      if (event.phase === GAMEPLAY_PHASE.TURN_START) {
        this.dispatch?.(setEventFulfilled(true))
        this.dispatch?.(
          effectsEndpoints.util.invalidateTags([
            { type: TAGS.EFFECTS, id: "ACTIVE-EFFECTS" }
          ])
        )
        this.dispatch?.(
          gameplayEndpoints.util.invalidateTags([
            { type: TAGS.GAMEPLAY, id: "LAST_LOGS" }
          ])
        )
      }
    }
    return this._bind(GAMEPLAY_SOCKETS.GAMEPLAY_STATE, handler)
  },

  bindGameplayEventListener() {
    const handler = (event: IGameplayEvent) => {
      console.log("bindGameplayEventListener", event)

      this.dispatch?.(addEvent(event))
      this.dispatch?.(setEventFulfilled(false))
    }
    return this._bind(GAMEPLAY_SOCKETS.GAMEPLAY_EVENT, handler)
  }
}
